<template>
  <div class="bar-chart-container">
    <!-- TODO: グラフサイズを変える場合、canvas自体のサイズ指定するしかなさそう？(他に方法があったらそれを適用したい) -->
    <BarChart :chart-data="chartData" :options="state.option" :style="{ width: '100%', height: '320px' }" />
  </div>
</template>

<script lang="ts">
import { PropType, SetupContext, defineComponent, reactive } from 'vue';
import { BarChart } from 'vue-chart-3';
import { Chart, Colors, elements, plugins, registerables } from 'chart.js';
import { OrderChartDateUnit } from '@/coreDomainsModule/table';

Chart.register(...registerables);

export interface IChartdata {
  labels: string[];
  datasets: Dataset[];
}

export interface Dataset {
  data: (number | null)[];
  backgroundColor?: string;
  borderColor?: string;
  borderRadius?: number;
  label?: string;
  labels?: string[];
  borderWidth?: number;
  fill?: boolean;
  type?: string;
  lineTension?: number;
  order?: number;
}

interface IChart {
  option: any;
}
export default defineComponent({
  name: 'Chart',
  components: { BarChart },
  props: {
    chartData: {
      type: Object as PropType<any>,
      default: null,
    },
    dateUnit: {
      type: String as PropType<OrderChartDateUnit>,
      default: 'day',
    },
  },
  setup(props, context: SetupContext) {
    const state: IChart = reactive<IChart>({
      // https://www.chartjs.org/docs/3.9.1/getting-started/v3-migration.html#_3-x-migration-guide
      // TODO: ここ参考に、多分動いてないからなんとかしたい
      option: {
        responsive: true,
        plugins: {
          legend: {
            align: 'start',
            labels: {
              generateLabels: (chart) => {
                const datasets = chart.data.datasets;
                const useTheseLabels = datasets.map((dataset, i) => {
                  return {
                    text: dataset.label,
                    fillStyle: dataset.backgroundColor,
                    strokeStyle: dataset.borderColor,
                    lineWidth: 0,
                    borderRadius: 5,
                    datasetIndex: i,
                  };
                });
                return useTheseLabels;
              },
            },
          },
        },
        layout: {
          padding: {
            top: 15,
            right: 50,
            bottom: 10,
            left: 20,
          },
        },
        interaction: {
          intersect: false,
        },
        scales: {
          x: {
            time: {
              unit: props.dateUnit,
            },
            stacked: true, //積み上げ棒グラフにする設定
          },
          y: {
            ticks: {
              color: '#757575', // Color for y-axis labels
              stepSize: 10, // Interval between ticks
            },
            stacked: true, //積み上げ棒グラフにする設定
          },
        },
        barPercentage: 1, // 棒の太さ
        categoryPercentage: 0.7, // カテゴリ間の間隔
      },
    }) as IChart;
    return { props, state };
  },
});
</script>

<style lang="scss" scoped>
.bar-chart-container {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  background-color: #ffffff;
}

.bar-chart-container >>> canvas {
  height: 320px;
}
</style>
